import moment from 'moment'
import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'
import requestGetEmployeeSociete from 'businessTraveller/api/requestGetEmployeeSociete'

const EMPLOYEE_SOCIETE_TTL_IN_SECONDS = 10 * 60 // 10 minutes

function fetchEmployeeSociete(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const businessId = state.businessTraveller.currentBusinessAccount?.business?.id
    const employeeSociete = state.businessTraveller.employeeSociete

    // Business account not ready yet or already fetching
    if (!businessId || employeeSociete?.fetching) return

    const isTtlExpired = !!(
      employeeSociete?.data?.fetchedAt &&
      moment().utc().diff(moment(employeeSociete.data.fetchedAt).utc(), 'seconds') >= EMPLOYEE_SOCIETE_TTL_IN_SECONDS
    )

    // Has fresh data within TTL — skip
    if (employeeSociete?.data && !isTtlExpired) return

    dispatch({
      type: API_CALL,
      api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_EMPLOYEE_SOCIETE,
      request: () => requestGetEmployeeSociete({ businessId }),
    })
  }
}

export default fetchEmployeeSociete
